module.exports = __webpack_public_path__ + "media/img/mask/polygon-e424adb73138e89c1eaf2b9c76010f07.svg";